// extracted by mini-css-extract-plugin
export default {"l_SwipeTextItem_main":"swipeTextItem_l_SwipeTextItem_main__vVtFs","highlight":"swipeTextItem_highlight__LQ+Sc"};